export default __webpack_public_path__ + "static/media/Charm of the Laughing Shadows.1fd03e56.jpg";